export default __webpack_public_path__ + "static/media/learn-more-about-publishing.c3085f9a.jpg";